/** 各层默认无区域，仅用户绘制后 localStorage 持久化 */
export const ZONES_SEED = []
